/* FILTER TABS (2026-09-14d) — barre horizontale a onglets, voir le
   commentaire en tete de snippets/faceted-filters.liquid. Un seul panneau
   ouvert a la fois. Delegation d'evenements sur document (pas de listener
   pose directement sur les onglets/panneaux) : ce bloc entier vit dans un
   conteneur data-ajax-container que Search & Discovery remplace par du HTML
   frais a CHAQUE changement de filtre (pour rafraichir les compteurs/etats
   actifs des autres filtres) — des listeners directs seraient perdus a
   chaque remplacement. La delegation sur document survit sans re-binding. */
(function () {
  "use strict";

  // 2026-10-07 — onglets "interrupteur" : un filtre a valeur unique (ex. "Fourré",
  // metachamp caracteristiques.fourre = "Oui") n'ouvre pas de panneau, un clic
  // sur l'onglet coche/decoche directement la case "Oui" (le JS natif du
  // theme rafraichit alors la grille). Liste blanche de libelles pour ne pas
  // transformer par erreur un filtre normal. Si l'index S&D garde une valeur
  // parasite (ancienne version booleenne), seule la case "Oui" est utilisee.
  var TOGGLE_LABELS = ["fourré"];

  function toggleBox(panel) {
    var boxes = panel.querySelectorAll(".filter-tabs__checkbox");
    for (var i = 0; i < boxes.length; i++) {
      if (String(boxes[i].value).trim().toLowerCase() === "oui") return boxes[i];
    }
    return null;
  }

  function markToggleTabs() {
    document.querySelectorAll("[data-filter-tab]").forEach(function (tab) {
      if (tab.hasAttribute("data-filter-toggle")) return;
      var label = (tab.firstChild ? tab.firstChild.textContent : tab.textContent).trim().toLowerCase();
      if (TOGGLE_LABELS.indexOf(label) === -1) return;
      var panel = document.getElementById(tab.dataset.filterTabPanel);
      if (!panel || !toggleBox(panel)) return;
      tab.setAttribute("data-filter-toggle", "");
      tab.setAttribute("aria-pressed", tab.classList.contains("filter-tabs__tab--active") ? "true" : "false");
      var count = tab.querySelector(".filter-tabs__tab-count");
      if (count) count.style.display = "none";
    });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", markToggleTabs);
  } else {
    markToggleTabs();
  }
  new MutationObserver(markToggleTabs).observe(document.documentElement, { childList: true, subtree: true });

  function closePanels(root) {
    root.querySelectorAll("[data-filter-panel]").forEach(function (panel) {
      panel.hidden = true;
    });
    root.querySelectorAll("[data-filter-tab]").forEach(function (tab) {
      tab.classList.remove("filter-tabs__tab--open");
    });
  }

  // 2026-09-14k/l — bulle d'explication sur les valeurs "Stade de motricite"
  // (voir .filter-tabs__opt-info/__opt-bubble dans assets/filter-tabs.css et
  // le Liquid dans snippets/faceted-filters.liquid). La bulle est en
  // position:fixed pour echapper au overflow-y:auto de .filter-tabs__panel
  // (qui la coupait sinon, retour utilisateur "tronquees, en second plan") —
  // sa position doit donc etre calculee en JS par rapport au viewport, au
  // survol ET au tap (plus de media query hover CSS seule).
  function positionBubble(icon) {
    var bubble = icon.querySelector(".filter-tabs__opt-bubble");
    if (!bubble) return null;
    var rect = icon.getBoundingClientRect();
    var width = bubble.offsetWidth || 210;
    var margin = 8;
    var left = rect.left + rect.width / 2 - width / 2;
    left = Math.max(margin, Math.min(left, window.innerWidth - width - margin));
    var below = rect.top < 110;
    bubble.classList.toggle("filter-tabs__opt-bubble--below", below);
    bubble.style.left = left + "px";
    if (below) {
      bubble.style.top = rect.bottom + 9 + "px";
      bubble.style.bottom = "auto";
    } else {
      bubble.style.bottom = window.innerHeight - rect.top + 9 + "px";
      bubble.style.top = "auto";
    }
    bubble.style.setProperty("--gdc-arrow-left", rect.left + rect.width / 2 - left + "px");
    return bubble;
  }

  function showBubble(icon) {
    var bubble = positionBubble(icon);
    if (bubble) bubble.classList.add("is-visible");
  }

  function hideAllBubbles() {
    document.querySelectorAll(".filter-tabs__opt-bubble.is-visible").forEach(function (bubble) {
      bubble.classList.remove("is-visible");
    });
  }

  // Survol desktop : mouseover/mouseout bullent (contrairement a
  // mouseenter/mouseleave), utilisables donc en delegation sur document.
  document.addEventListener("mouseover", function (e) {
    var icon = e.target.closest(".filter-tabs__opt-info");
    if (icon) showBubble(icon);
  });
  document.addEventListener("mouseout", function (e) {
    var icon = e.target.closest(".filter-tabs__opt-info");
    if (icon && (!e.relatedTarget || !icon.contains(e.relatedTarget))) hideAllBubbles();
  });
  document.addEventListener(
    "focusin",
    function (e) {
      var icon = e.target.closest(".filter-tabs__opt-info");
      if (icon) showBubble(icon);
    },
    true
  );
  document.addEventListener(
    "focusout",
    function (e) {
      if (e.target.closest(".filter-tabs__opt-info")) hideAllBubbles();
    },
    true
  );
  window.addEventListener(
    "scroll",
    function () {
      hideAllBubbles();
    },
    true
  );

  document.addEventListener("click", function (e) {
    var info = e.target.closest(".filter-tabs__opt-info");
    if (info) {
      // Tap mobile : bascule (pas de vrai hover tactile). preventDefault
      // empeche ce clic de cocher la case du filtre porte par le <label>
      // parent de l'icone.
      e.preventDefault();
      var bubble = info.querySelector(".filter-tabs__opt-bubble");
      var wasVisible = bubble && bubble.classList.contains("is-visible");
      hideAllBubbles();
      if (!wasVisible) showBubble(info);
      return;
    }
    hideAllBubbles();

    var tab = e.target.closest("[data-filter-tab]");
    if (tab) {
      var root = tab.closest("[data-filter-tabs]");
      if (!root) return;
      var panel = root.querySelector("#" + tab.dataset.filterTabPanel);
      if (!panel) return;
      if (tab.hasAttribute("data-filter-toggle")) {
        // Onglet interrupteur : on ferme les autres panneaux et on bascule
        // directement la case "Oui" (pas de panneau a ouvrir).
        closePanels(root);
        var box = toggleBox(panel);
        if (box && !box.disabled) {
          tab.classList.toggle("filter-tabs__tab--active", !box.checked);
          box.click();
        }
        return;
      }
      var wasOpen = !panel.hidden;
      closePanels(root);
      if (!wasOpen) {
        panel.hidden = false;
        tab.classList.add("filter-tabs__tab--open");
      }
      return;
    }

    // Clic en dehors de toute barre de filtres ouverte : on referme tout.
    // Un clic A L'INTERIEUR d'un panneau deja ouvert (ex: cocher une case)
    // ne doit PAS le fermer, d'ou le closest ci-dessous.
    if (!e.target.closest("[data-filter-tabs]")) {
      document.querySelectorAll("[data-filter-tabs]").forEach(closePanels);
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") {
      document.querySelectorAll("[data-filter-tabs]").forEach(closePanels);
      hideAllBubbles();
    }
  });
})();
